import api from '@/api/index.js'

const operator = {
  state: {
    loading: false,
    updating: false,
    data: [],
    instance: null,
    error: null
  },

  mutations: {
    SET_OPERATORS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_OPERATORS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_OPERATOR: (state, response) => {
      state.updating = false;
      state.instance = response;
    },
    SET_OPERATORS_ERROR: (state, error) => {
      state.error = error;
      state.updating = false;
      state.loading = false;
    },
    SET_OPERATORS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
  },

  actions: {
    LoadOperators({commit}) {
      commit('SET_OPERATORS_ERROR', null)
      commit('SET_OPERATORS_LOADING', true)
      return api.get('operators?limit=150&offset=0')
        .then((response) => {
          commit('SET_OPERATORS', response)
        })
        .catch((error) => {
          commit('SET_OPERATORS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    LoadOperator({commit}, id) {
      commit('SET_OPERATORS_ERROR', null)
      commit('SET_OPERATORS_UPDATING', true)
      return api.get(`operators/${id}`)
        .then((response) => {
          commit('SET_OPERATOR', response)
        })
        .catch((error) => {
          commit('SET_OPERATORS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateOperator({commit}, payload) {
      commit('SET_OPERATORS_UPDATING', true);
      commit('SET_OPERATOR', null);
      commit('SET_ERROR', null);
      commit('SET_OPERATORS_ERROR', null)
      return api.post(`operators`, payload)
        .then((response) => {
          commit('SET_OPERATOR', response.body);
        })
        .catch((error) => {
          commit('SET_OPERATORS_ERROR', error);
          commit('SET_OPERATORS_UPDATING', false);
        })
    },
    UpdateOperator({commit}, payload) {
      commit('SET_OPERATORS_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_OPERATORS_ERROR', null)
      return api.put(`operators/${payload.id}`, payload.data)
        .then((response) => {
          commit('SET_OPERATOR', response.body);
        })
        .catch((error) => {
          commit('SET_OPERATORS_ERROR', error);
          commit('SET_OPERATORS_UPDATING', false);
        })
    },
    DeleteOperator({commit}, id) {
      commit('SET_OPERATORS_UPDATING', true);
      commit('SET_OPERATORS_ERROR', null)
      return api.delete(`operators/${id}`)
        .then((response) => {
          commit('SET_OPERATORS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_OPERATORS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_OPERATORS_UPDATING', false);
        })
    },
  },
}

export default operator

